export interface NomenclatorValueDTO {
    amount: number;
    medicalAmount?: number | null;
    expensesAmount?: number | null;
    coveragePercentage: number;
}

export interface NomenclatorDTO {
    nomenclator: number | null;
    code: string | null;
    description: string | null;
    codeanddescription:string | null;
    nomenclatortype: number | null;
    nomenclatortypedesc:string | null;
    billingbyhour: boolean | null;
    defaultprice?: number | null;
    honorarium?: number | null;
}

export const defaultNomenclatorDTO: NomenclatorDTO = {
    nomenclator: -1,
    code: '',
    description: '',
    codeanddescription: '',
    nomenclatortype: -1, 
    nomenclatortypedesc: '',
    billingbyhour: false,
    defaultprice: null,
    honorarium: null
};

export const defaultAllNomenclatorDTO: NomenclatorDTO = {
    nomenclator: -1,
    code: '',
    description: '',
    codeanddescription: '<Todos>',
    nomenclatortype: -1, 
    nomenclatortypedesc: '<Todos>',
    billingbyhour: false,
    defaultprice: null,
    honorarium: null
};

export const defaultSlashNomenclatorDTO: NomenclatorDTO = {
    nomenclator: -1,
    code: '',
    description: '',
    codeanddescription: ' - ',
    nomenclatortype: -1, 
    nomenclatortypedesc: '',
    billingbyhour: false,
    defaultprice: null,
    honorarium: null
};